export default __webpack_public_path__ + "static/media/671ee4f332275f33c8e5e64d44e8add1.svg";